module.exports = __webpack_public_path__ + "img/sleeve_cap_rise.2bdbb3d8.png";